import axios from "axios";
import { API_BASE_URL } from "../../config/api";
import { maybeEmitPermissionErrorFromAxios403 } from "../../utils/permissionAlertEmitter";
import { updateLastActivity } from "../../utils/sessionActivity";
import { persistAuthToken } from "../../utils/authTokenRefresh";
import { clearTenantSessionStorage } from "../../utils/authSession";
import { axiosAuthDefaults } from "./axiosAuthConfig";

const tenantAxiosInstance = axios.create({
  baseURL: API_BASE_URL,
  ...axiosAuthDefaults,
});

// Response Interceptor: Token süresi dolarsa tenant login'e yönlendir
tenantAxiosInstance.interceptors.response.use(
  (response) => {
    persistAuthToken(response, "tokenTenant");
    updateLastActivity();
    return response;
  },
  (error) => {
    const url = error.config?.url || "";
    const isLoginEndpoint = url.includes("/login") || url.includes("/register") || url.includes("/verify-2fa");
    if (error.response && error.response.status === 401 && !isLoginEndpoint) {
      clearTenantSessionStorage();
      window.location.href = "/corporate-login";
    }
    maybeEmitPermissionErrorFromAxios403(error);
    return Promise.reject(error);
  }
);

export default tenantAxiosInstance;


